module.exports = __webpack_public_path__ + "ratings reviews desktop.svg?3b9d751cfa74a5dca42f779dfae66335";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/ratings reviews desktop.svg
// module id = 117
// module chunks = 0